module.exports = __webpack_public_path__ + "static/media/create-wallet-t2.61ce4036.nom";